import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  get,
  reduce,
} from 'lodash';
import AdvancedFilters from './AdvancedFilters';
import ServiceTypesSelect from './ServiceTypesSelect';
import { MAP_CENTER } from './DistanceFilter';

const defaultAdvancedFilters = {
  accessibility_options: [],
  address: '',
  counties: [],
  distance_from: MAP_CENTER,
  distance: 'any',
  languages: [],
  places: [],
  restricted_to: [],
  states: [],
};

class Search extends Component {
  constructor(props) {
    super(props);

    this.state = {
      values: {
        searchAdvanced: '',
        searchTerm: '',
        serviceType: '',
        ...defaultAdvancedFilters,
      },
    };

    this.onClearAllFilters = this.onClearAllFilters.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onFieldChange = this.onFieldChange.bind(this);
    this.onMultiFieldChange = this.onMultiFieldChange.bind(this);
  }

  onClearAllFilters() {
    const {
      values,
    } = this.state;

    this.setState({
      values: {
        ...values,
        ...defaultAdvancedFilters,
      },
    });
  }

  onSubmit(event) {
    event.preventDefault();
    const { onSubmit } = this.props;
    const { values } = this.state;
    onSubmit(values);
  }

  onFieldChange(event) {
    const key = get(event, 'target.name');
    const value = get(event, 'target.value', '');
    if (key) {
      this.setState(state => ({
        values: {
          ...state.values,
          [key]: value,
        },
      }));

      return value;
    }
    return null;
  }

  onMultiFieldChange(event) {
    const key = get(event, 'target.name');

    if (key) {
      const options = get(event, 'target.options', []);

      const value = reduce(options, (acc, opt) => {
        if (opt.selected && opt.value !== '') {
          return [...acc, opt.value];
        }
        return acc;
      }, []);

      this.setState(state => ({
        values: {
          ...state.values,
          [key]: value,
        },
      }));

      return value;
    }
    return null;
  }

  render() {
    const {
      enums,
      google,
      map,
      onToggleAdvancedFilters,
      serviceTypes,
      showAdvancedFilters,
    } = this.props;
    const {
      values,
    } = this.state;

    const searchClass = `uu-search-container ${showAdvancedFilters ? 'uu-search-container--open' : ''}`;
    const population = get(enums, 'groups.programs.population');
    const accessibility = get(enums, 'groups.programs.accessibility_options');
    const languages = get(enums, 'base.languages');
    const states = get(enums, 'geography.us_states');

    return (
      <div className={searchClass}>
        <form onSubmit={this.onSubmit}>
          <div className="uu-search-container__header">
            <ServiceTypesSelect
              values={values}
              onFieldChange={this.onFieldChange}
              serviceTypes={serviceTypes}
            />
            <div className="uu-search-container__field uu-search-container__term">
              <label htmlFor="uu-search-term">
                Search
              </label>
              <input
                id="uu-search-term"
                name="searchTerm"
                type="text"
                value={values.searchTerm}
                onChange={this.onFieldChange}
                placeholder="Search"
              />
            </div>
            <div className="uu-search-container__field">
              <button
                type="submit"
              >
                Search
              </button>
            </div>
            <div className="uu-search-container__field">
              <button
                type="button"
                className="uu-toggle-advanced-filters"
                onClick={onToggleAdvancedFilters}
              >
                Filters
              </button>
            </div>
          </div>
          <AdvancedFilters
            onFieldChange={this.onFieldChange}
            onMultiFieldChange={this.onMultiFieldChange}
            values={values}
            population={population}
            accessibility={accessibility}
            languages={languages}
            states={states}
            onClearAll={this.onClearAllFilters}
            google={google}
            map={map}
          />
        </form>
      </div>
    );
  }
}

Search.propTypes = {
  enums: PropTypes.object.isRequired,
  google: PropTypes.object,
  map: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  onToggleAdvancedFilters: PropTypes.func.isRequired,
  serviceTypes: PropTypes.array.isRequired,
  showAdvancedFilters: PropTypes.bool.isRequired,
};

Search.defaultProps = {
  google: {},
  map: {},
};

export default Search;



// WEBPACK FOOTER //
// ./public/js/components/Search/index.jsx